"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class LikedPostsStructurer {
    structure(likedPosts) {
        const strucuturedLikedPosts = {};
        for (const id in likedPosts) {
            if (!strucuturedLikedPosts[likedPosts[id].website]) {
                strucuturedLikedPosts[likedPosts[id].website] = [];
            }
            strucuturedLikedPosts[likedPosts[id].website].push(likedPosts[id]);
        }
        return strucuturedLikedPosts;
    }
}
exports.default = LikedPostsStructurer;
